// extracted by mini-css-extract-plugin
export default {"modalCTAWrapper":"DepartmentAddEdit_modalCTAWrapper__wm0Yc"};